import Viewer from '@/widget/Editor/Viewer'
import { useQuery } from '@tanstack/react-query'
import Alert from 'react-bootstrap/Alert'
import Card from 'react-bootstrap/Card'
import Spinner from 'react-bootstrap/Spinner'
import type { Article } from './data'
import { fetchUserArticles } from './data'
import { pointer } from './style.css'

export default function ArticleList() {
  const { data, isLoading, isError } = useQuery<Article[]>({
    queryKey: ['article'],
    queryFn: fetchUserArticles,
  })
  return isLoading ? (
    <Spinner />
  ) : isError ? (
    <Alert variant="danger">error</Alert>
  ) : (
    data?.map((article) => (
      <Card>
        <Card.Body className={pointer}>
          <Card.Title>{article.title}</Card.Title>
          <Viewer content={article.content} />
        </Card.Body>
      </Card>
    ))
  )
}
